import { render, staticRenderFns } from "./IconBadge.vue?vue&type=template&id=19b5ee9c"
import script from "./IconBadge.vue?vue&type=script&lang=js"
export * from "./IconBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports